var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F7F8FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14,
    fill: "#0516C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9985 10.5C15.7425 10.5 14.28 12.0143 12.5505 12.5663C11.847 12.7913 11.4952 12.903 11.3527 13.0612C11.2102 13.2187 11.169 13.4505 11.0857 13.9125C10.1932 18.8595 12.1432 23.433 16.7932 25.2135C17.292 25.4048 17.5417 25.5 18.0007 25.5C18.4597 25.5 18.7102 25.404 19.2097 25.2128C23.859 23.433 25.8067 18.8595 24.9142 13.9125C24.831 13.4505 24.789 13.2188 24.6465 13.0605C24.504 12.9023 24.153 12.7905 23.4495 12.5663C21.7192 12.0143 20.2545 10.5 17.9985 10.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.75C15.75 18.75 16.5 18.75 17.25 20.25C17.25 20.25 19.6328 16.5 21.75 15.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompliance);
export default __webpack_public_path__ + "static/media/compliance.e490a0a6115e5ef840c924e6d8b8ac17.svg";
export { ForwardRef as ReactComponent };